import { useAuth } from '@/context/AuthContext';
import { useTasks } from '@/context/TaskContext';
import { useLists } from '@/context/ListContext';

const LOCAL_TASKS_LIMIT = 1;
const LOCAL_LISTS_LIMIT = 1;

export const useLocalTaskLimits = () => {
  const { session } = useAuth();
  const { tasks } = useTasks();
  const { lists } = useLists();

  // Simple, direct limit checks
  const canCreateTask = () => {
    if (session) return true; // Authenticated users have no limits
    return tasks.length < LOCAL_TASKS_LIMIT;
  };

  const canCreateList = () => {
    if (session) return true; // Authenticated users have no limits
    return lists.length < LOCAL_LISTS_LIMIT;
  };

  const isAtTaskLimit = () => {
    if (session) return false;
    return tasks.length >= LOCAL_TASKS_LIMIT;
  };

  const isAtListLimit = () => {
    if (session) return false;
    return lists.length >= LOCAL_LISTS_LIMIT;
  };

  return {
    canCreateTask,
    canCreateList,
    isAtTaskLimit,
    isAtListLimit,
    taskLimit: LOCAL_TASKS_LIMIT,
    listLimit: LOCAL_LISTS_LIMIT
  };
};

export default useLocalTaskLimits;